import ArgonBox from "components/ArgonBox";
import React, { useEffect, useState } from "react";
import { Grid, Card, Avatar, Chip } from "@mui/material";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import EditIcon from "@mui/icons-material/Edit";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import Table from "examples/Tables/Table";
import ParentsProfileTableData from "./data/parentProfileTableData";
import ParentsProfileTableData2 from "Views/people/parents/parentProfile/data/parentProfileTableData2";
import ArgonButton from "components/ArgonButton";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArgonInput from "components/ArgonInput";
import MinisDialog from "components/MiniDialog/MiniDialog";
import { useParams } from "react-router-dom";
import axios from "utils/api";
import { baseURL } from "utils/api";

function profile() {
  const { columns, rows } = ParentsProfileTableData;

  const { columns: columns1, rows: rows1 } = ParentsProfileTableData2;

  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { id } = useParams();
  console.log(id);

  const [parent, setParent] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentTableRows, setStudentTableRows] = useState([]);

  useEffect(() => {
    // Fetch parent details
    axios
      .get(`${baseURL}/parent/profile/${id}`)
      .then((res) => {
        console.log("parent data", res.data);
        if (res.data.success) {
          setParent(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // Fetch students by parent id
    axios
      .get(`${baseURL}/student?parentId=${id}`)
      .then((res) => {
        console.log("students by parent id", res.data);
        if (res.data.success && res.data.data.length > 0) {
          setStudents(res.data.data);
          // API data ko table rows me map karna
          const rows = res.data.data.map((student, index) => ({
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {index + 1}
              </ArgonTypography>
            ),
            "student Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.name || "NA"}
              </ArgonTypography>
            ),
            Gender: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.gender || "NA"}
              </ArgonTypography>
            ),
            "Date of Birth": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {new Date(student.dob).toLocaleDateString() || "NA"}
              </ArgonTypography>
            ),
            "School/College/University Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.schoolName || "NA"}
              </ArgonTypography>
            ),
            "Preferred Time Duration": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.preferredTimeDuration || "NA"} mins
              </ArgonTypography>
            ),
            "Tuition Tenure": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.noOfClassesPerWeek || "NA"} classes/week
              </ArgonTypography>
            ),
            "mode Of Tuition": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.modeOfTuition || "NA"}
              </ArgonTypography>
            ),
            // "Tutors Level": (
            //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
            //     {student.currentSubscription?.tutorAccess || "N/A"}
            //   </ArgonTypography>
            // ),
          }));
          setStudentTableRows(rows);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  console.log("parents data", parent);
  console.log(students);

  return (
    <ArgonBox mt={4}>
      {/* Header Profile Card */}
      <Card
        sx={{
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 6px 4px rgba(0,0,0,0.12)",
          mb: 3,
          background: "white",
        }}
      >
        {/* Background Header */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: "16px",
                p: 2.5,
                boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
                background: "linear-gradient(135deg, #ffffff 0%, #fbfbfb 100%)",
              }}
            >
              <Grid container spacing={2} alignItems="center" mb={2}>
                <Grid item xs={12} sm={4} textAlign={{ xs: "center", sm: "left" }}>
                  <ArgonBox display="flex" alignItems="center" gap={1.5}>
                    <ArgonAvatar
                      src={parent?.profileImage}
                      alt={parent?.fullName}
                      size="lg"
                      sx={{
                        width: 48,
                        height: 48,
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                      }}
                    >
                      <PersonIcon sx={{ color: "white", fontSize: 24 }} />
                    </ArgonAvatar>
                    <ArgonBox>
                      <ArgonTypography
                        variant="h5"
                        fontWeight="bold"
                        sx={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          mb: 0.5,
                        }}
                      >
                        {parent?.fullName || "Parent Name"}
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                </Grid>

                {/* Parent Info Cards */}
                <Grid item xs={12} sm={8}>
                  <Grid container spacing={1.5}>
                    {/* Joined Date */}
                    <Grid item xs={6} sm={6}>
                      <ArgonBox
                        sx={{
                          p: 1.5,
                          bgcolor: "#f9f9ff",
                          borderRadius: 2,
                          textAlign: "center",
                          "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
                        }}
                      >
                        <CalendarTodayIcon color="primary" sx={{ fontSize: 20, mb: 0.3 }} />
                        <ArgonTypography variant="caption" display="block" color="text">
                          Joined
                        </ArgonTypography>
                        <ArgonTypography variant="body2" fontWeight="medium">
                          {parent?.createdAt
                            ? new Date(parent.createdAt).toLocaleDateString()
                            : "NA"}
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Contact Information */}

              <Grid container spacing={2}>
                {/* Email */}
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      minHeight: 120,
                      background: "linear-gradient(135deg, #e3f2fd, #bbdefb)",
                      border: "1px solid #90caf9",
                    }}
                  >
                    <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                      <EmailIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                      <ArgonTypography variant="subtitle2" fontWeight="medium">
                        Email Address
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonTypography variant="body2" fontWeight="medium">
                      {parent?.email}
                    </ArgonTypography>
                  </Card>
                </Grid>

                {/* Phone */}
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      minHeight: 120,
                      background: "linear-gradient(135deg, #e8f5e8, #c8e6c9)",
                      border: "1px solid #81c784",
                    }}
                  >
                    <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                      <PhoneIcon sx={{ color: "#388e3c", fontSize: 20 }} />
                      <ArgonTypography variant="subtitle2" fontWeight="medium">
                        Phone Number
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonTypography mx={1} variant="body2" fontWeight="medium">
                      {parent?.phone}
                    </ArgonTypography>
                  </Card>
                </Grid>

                {/* Address */}
                {/* <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      minHeight: 120,
                      background: "linear-gradient(135deg, #e0feffff, #b2e5ffff)",
                      border: "1px solid #4dffedff",
                    }}
                  >
                    <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                      <LocationOnIcon sx={{ color: "#f57c00", fontSize: 20 }} />
                      <ArgonTypography variant="subtitle2" fontWeight="medium">
                        Address
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonTypography variant="body2" fontWeight="medium">
                      123 Main Street, NY 10001
                    </ArgonTypography>
                  </Card>
                </Grid> */}
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Card>

      <ArgonBox py={3}>
        <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 3 }} mb={2}>
          Student List
        </ArgonTypography>
        <ArgonBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          <Table columns={columns} rows={studentTableRows} />
        </ArgonBox>
      </ArgonBox>

      <ArgonBox
        mt={2}
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        sx={{ gap: "10%" }} // beech ka gap
      >
        {/* LEFT SIDE (40%) */}
        <ArgonBox flex="0 0 45%">
          <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 2 }} mb={2}>
            Class Assigned to
          </ArgonTypography>

          <ArgonBox
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
              overflow: "hidden",
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
            }}
          >
            <Table columns={columns1} rows={rows1} />
          </ArgonBox>
        </ArgonBox>

        {/* RIGHT SIDE (40%) */}
        <ArgonBox
          mt={2}
          flex="0 0 45%"
          sx={{
            // background: "linear-gradient(135deg, #fbfcfcff 0%, #eceaeaff 100%)",
            borderRadius: "18px",
            border: "none",
            boxShadow: "0 6px 24px 0 rgba(0, 188, 212, 0.10)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative background dots */}
          <ArgonBox
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 200,
              height: 80,
              background: "radial-gradient(circle, #00bcd4 0%, transparent 70%)",
              opacity: 0.12,
              zIndex: 0,
            }}
          />
          <ArgonBox p={3} sx={{ position: "relative", zIndex: 1 }}>
            {/* Header Row */}
            <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <ArgonBox display="flex" alignItems="center" gap={1}>
                <span style={{ fontSize: 28, marginRight: 6 }}>📝</span>
                <ArgonTypography variant="h6" fontWeight="bold" color="primary">
                  Notes
                </ArgonTypography>
              </ArgonBox>

              <ArgonButton onClick={handleClick} variant="contained" size="medium" color="primary">
                Add Note
              </ArgonButton>
            </ArgonBox>

            {/* Footer link */}
            <ArgonTypography
              variant="body2"
              color="secondary"
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                letterSpacing: 0.5,
                transition: "color 0.2s",
                "&:hover": { color: "#2379f1ff" },
              }}
            >
              Show All Notes →
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
      </ArgonBox>

      {/* Modal */}

      <MinisDialog
        open={open}
        onClose={handleClose}
        title="Add Tutor Notes"
        label="Tutor Complaint"
        placeholder="Enter tutor related complaint"
      />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            padding: "8px",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #eee",
            pb: 1,
          }}
        >
          <ArgonTypography onclick={handleClick} variant="h5" fontWeight="bold">
            Add Notes
          </ArgonTypography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Body */}
        <DialogContent sx={{ mt: 2 }}>
          <form>
            <ArgonBox mb={2}>
              <ArgonTypography variant="body2" fontWeight="medium" mb={1} color="text">
                Complaint
              </ArgonTypography>
              <ArgonInput name="Notes" placeholder="Enter Complaint" multiline rows={4} fullWidth />
            </ArgonBox>

            {/* Footer buttons */}
            <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
              <ArgonButton
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                sx={{ borderRadius: "8px", textTransform: "none" }}
              >
                Cancel
              </ArgonButton>
              <ArgonButton type="submit" variant="contained" color="primary">
                Save
              </ArgonButton>
            </ArgonBox>
          </form>
        </DialogContent>
      </Dialog>
    </ArgonBox>
  );
}

export default profile;
